import React from 'react';
import {ButtonTypes} from "./Button.types";
import clsx from "clsx";

export const Button: React.FC<ButtonTypes> = (props) => {
    const {disabled = false} = props;
    return (
        <button
            id={props.id}
            className={clsx(props.className)}
            onClick={props.onClick}
            disabled={disabled}
            ref={props.ref}
        >
            {props.children}
        </button>
    )
}
